/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { put, select, take } from 'redux-saga/effects';

import { Repository } from 'src/components/types';
import { loadBranchingModel } from 'src/redux/branches';
import { addRecentlyViewedRepository } from 'src/redux/recently-viewed-repositories';
import {
  FetchRepositoryMainBranch,
  LoadRepositoryPage,
} from 'src/sections/repository/actions';
import { getCurrentRepository } from 'src/selectors/repository-selectors';

import fetchRepositoryBranch from '../sections/repository/actions/fetch-repository-branch';

export function* loadRepositorySuccess() {
  while (true) {
    yield take(LoadRepositoryPage.SUCCESS);
    const repository: Repository = yield select(getCurrentRepository);
    yield put(addRecentlyViewedRepository(repository));

    if (repository.mainbranch && repository.mainbranch.name) {
      yield put(
        fetchRepositoryBranch(
          FetchRepositoryMainBranch,
          repository.full_name,
          repository.mainbranch.name
        )
      );
    }

    const [repositoryOwner, repositorySlug] = repository.full_name.split('/');
    const options = {
      repositoryOwner,
      repositorySlug,
    };

    yield put(loadBranchingModel(options));
  }
}
